import { SxProps } from '@mui/material';

import { SIDE_MENU_WIDTH } from '@/config/theme/theme.ts';
import { themeColors } from '@/config/theme/themeColors.ts';

export const LeftBarNavigationTabStyles: SxProps = {
  '&.MuiButtonBase-root': {
    '&.MuiTab-root': {
      backgroundColor: 'transparent',
      border: 'none',
      borderLeft: '3px solid transparent',
      color: themeColors.greyDark,
      fontSize: '10px',
      fontWeight: 500,
      lineHeight: '14px',
      minHeight: 60,
      minWidth: '0',
      px: 0.5,
      py: 1,
      transition: 'background-color 160ms ease, border-color 160ms ease',
    },
    textAlign: 'center',
  },
  width: '100%',
};

export const LeftBarNavigationTabsStyles: SxProps = {
  '& .MuiButtonBase-root': {
    '&.Mui-disabled': {
      color: themeColors.grey,
      opacity: 1,
    },
    '&.MuiTabScrollButton-root': {
      color: themeColors.greyDark,
      height: '30px',
    },
  },
  '& .MuiTab-root': {
    '&:hover': {
      backgroundColor: '#F3F7F7',
    },
    '&.Mui-selected': {
      backgroundColor: themeColors.accentColor10,
      borderLeftColor: themeColors.accentColor,
      color: themeColors.accentColor,
    },
    backgroundColor: 'transparent',
    border: 'none',
    color: themeColors.greyDark,
  },
  backgroundColor: '#FBFCFC',
  borderRight: `1px solid ${themeColors.stroke}`,
  boxSizing: 'border-box',
  flexShrink: 0,
  height: '100%',
  maxWidth: SIDE_MENU_WIDTH,
  minWidth: SIDE_MENU_WIDTH,
  overflowX: 'hidden',
  width: SIDE_MENU_WIDTH,
};
